"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _imutils = require("@tencent/imutils");

const mids = {
  cgi_http_timeout: 35417255,
  //  http 请求10s超时
  cgi_http_status_error: 35417256,
  //  http 请求10s超时
  cgi_params_error: 35417257,
  // 100001：参错错误，出现这种情况很可能是页面参数传错了， 需要前端同学紧急处理（除了人肉构造参数的情况）
  cgi_server_error: 35417258,
  //  100003：服务错误，服务器挂了，需要后台同学紧急处理
  cgi_server_timeout: 35417259,
  // 100012：服务超时错误，服务器过载了，需要后台同学紧急处理
  cgi_other_error: 35417260,
  // 其他错误
  cgi_succ: 35417261 // 接口调用成功

};

_imutils.request.init({
  mids
});

var _default = _imutils.request;
exports.default = _default;